<template>
    <div class="rounded">
        <draggable :list="section.tasks" draggable=".draggable" handle=".handle"
                   :group="'tasks'" @change="update">
            <contracted-works-task v-for="task in section.tasks" :key="task.id"
                                   :showItemProgress="false"
                                   :search="search"
                                   :readonly="readonly"
                                   :contracted-works="contractedWorks"
                                   :show-omitted="showOmitted"
                                   :section="section"
                                   :latest="latest"
                                   @updated="update"
                                   :currently-building="currentlyBuilding"
                                   :current-viewing="currentViewing"
                                   @editBuildup="(i) => $emit('editBuildup',i)"
                                   :show-total="showTotal"
                                   :latest-progress-report="latestProgressReport"
                                   :task="task" :ref="(readonly?'readonly-':'')+'tasks'"></contracted-works-task>
        </draggable>

        <!-- New Task Item. -->
        <div class="flex -mb-px bg-white" v-if="canEdit()">
            <div class="w-6 flex-shrink-0 self-center">
                <i class="fa fa-plus text-xs font-bold text-gray-300"></i>
            </div>
            <div class="w-16">
                <input
                    :placeholder="'Ref...'"
                    class="text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10 bg-white"
                    type="text"
                    @input="addNewFromReference"
                    v-model="newTask.reference"
                >
            </div>
            <div class="flex-1 ml-0">
                <input
                    placeholder="Add new task..."
                    class="text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10 bg-white"
                    type="text"
                    ref="name"
                    @input="addNewFromName"
                    v-model="newTask.name"
                >
            </div>
            <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
            </div>
        </div>

        <!-- Total Amount. -->
        <div class="flex text-xs text-gray-500 text-right font-semibold bg-white" v-if="showTotal" :key="totalValueKey">
            <div class="flex-1 px-2 py-1">Section total</div>
            <div class="w-20 -ml-px px-2 py-1" v-text="totalValue()">
            </div>
            <div class="w-6 flex-shrink-0 ml-2"></div>
        </div>
        <div class="py-2" v-else></div>

    </div>
</template>

<script>
import draggable from 'vuedraggable'
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import {toCurrency, uuid} from "../../../utils";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import ContractedWorksTask from "./ContractedWorksTask.vue";
import ContractedWorksTimelinePanel from "./ContractedWorksTimelinePanel.vue";

export default {
    components: {
        ContractedWorksTimelinePanel,
        ContractedWorksTask,
        UiDropdownDivider,
        UiDropdown,
        UiDropdownItem,
        draggable,
    },
    props: {
        search: '',
        latest: Object,
        contractedWorks: Object,
        contract: Object,
        preliminaries: Array,
        showItemProgress: Boolean,
        showOmitted: Boolean,
        readonly: true,
        showTotal: false,
        currentViewing: false,
        currentlyBuilding: false,
        latestProgressReport: Object,
    },
    data() {
        return {
            newTask: {
                reference: null,
                name: null,
            },
            name: 'Preliminaries',
            original: this.latest ? {'id': 'Preliminaries', tasks: this.latest.preliminaries} : null,
            totalValueKey: 0,
            section: {'id': 'Preliminaries', tasks: this.preliminaries}
        }
    },
    computed: {},
    methods: {
        totalValue() {
            let value = 0;
            this.section.tasks.forEach((task) => {
                task.items.forEach((i) => {
                    if ((i.status === 'OMITTED') || (i.proposedStatus === 'OMITTED')) {
                    } else {
                        value += parseFloat(i.value ? (i.value.replace(/[^\d.-]/g, '')) : 0);
                    }
                })
            })
            return toCurrency(value)
        },
        canEdit() {
            return (!this.readonly)
        },
        canMove() {
            return (!this.readonly)
        },
        addNewFromReference() {
            this.section.tasks.push({
                id: uuid(),
                reference: this.newTask.reference,
                name: this.newTask.name,
                items: [],
                proposedStatus: 'ADDED',
            })
            this.$nextTick(() => {
                this.$refs.tasks.at(-1).update()
                this.newTask = {reference: null, name: null}
                this.$refs.tasks.at(-1).$refs.reference.focus()
            })
        },
        addNewFromName() {
            this.section.tasks.push({
                id: uuid(),
                reference: this.newTask.reference,
                name: this.newTask.name,
                items: [],
                proposedStatus: 'ADDED',
            })
            this.$nextTick(() => {
                this.$refs.tasks.at(-1).update()
                this.newTask = {reference: null, name: null}
                this.$refs.tasks.at(-1).$refs.name.focus()
            })
        },
        updateState() {
            this.preliminaries.splice(0, this.preliminaries.length, ...this.section.tasks)
            this.totalValueKey++;
        },
        update(snapshot) {
            this.updateState()
            this.$emit('updated', snapshot)
        },
        addSnapshot() {
            this.updateState()
            this.$emit('updated', true)
        },
        revert() {
            if (this.hasChanged()) {
                this.section.name = this.original.name
                this.name = this.section.name
            }
            this.proposedStatus = null
        },
    },
}
</script>
